import {
  Text,
  HStack,
  Flex,
  Box,
} from '@chakra-ui/react';
import React from 'react';

import type { NavGroupItem } from 'types/client/navigation';

import IconSvg from 'ui/shared/IconSvg';

import LightningLabel from '../LightningLabel';
import NavLinkIcon from '../NavLinkIcon';
import useNavLinkStyleProps from '../useNavLinkStyleProps';
import { checkRouteHighlight } from '../utils';

type Props = {
  item: NavGroupItem;
  onClick: () => void;
  isExpanded?: boolean;
  hideIcon?: boolean;
};

const NavLinkGroup = ({ item, onClick, isExpanded, hideIcon }: Props) => {
  const styleProps = useNavLinkStyleProps({ isActive: item.isActive, isExpanded });

  const isHighlighted = checkRouteHighlight(item.subItems);

  return (
    <Box as="li" listStyleType="none" w="100%" onClick={ onClick }>
      <Box
        { ...styleProps.itemProps }
        w="100%"
        px={ hideIcon ? 0 : 2 }
        aria-label={ `${ item.text } link group` }
      >
        <Flex justifyContent="space-between" width="100%" alignItems="center" pr={ 1 }>
          <HStack spacing={ 0 } overflow="hidden">
            { !hideIcon && <NavLinkIcon item={ item }/> }
            <Text
              { ...styleProps.textProps }
              ml={ hideIcon ? 0 : 3 }
              fontSize={ hideIcon ? '14px' : undefined }
              fontWeight={ hideIcon ? 500 : undefined }
            >
              { item.text }
            </Text>
            { isHighlighted && (<LightningLabel iconColor={ styleProps.itemProps.bgColor }/>) }
          </HStack>
          <IconSvg name="arrows/east-mini" transform="rotate(-90deg)" boxSize={ 5 }/>
        </Flex>
      </Box>
    </Box>
  );
};

export default NavLinkGroup;
